const LOTTERY_SHARE_PURCHASE_ATTRIBUTION_KEY =
  "lottery_share_purchase_attribution";

function getTodayString() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function saveLotterySharePurchaseAttribution(shareKey) {
  if (!shareKey) return;
  localStorage.setItem(
    LOTTERY_SHARE_PURCHASE_ATTRIBUTION_KEY,
    JSON.stringify({
      share_key: shareKey,
      date: getTodayString(),
    })
  );
}

export function getTodayLotterySharePurchaseAttribution() {
  const raw = localStorage.getItem(LOTTERY_SHARE_PURCHASE_ATTRIBUTION_KEY);
  if (!raw) return null;

  try {
    const attribution = JSON.parse(raw);
    if (
      !attribution ||
      !attribution.share_key ||
      attribution.date !== getTodayString()
    ) {
      clearLotterySharePurchaseAttribution();
      return null;
    }

    return attribution.share_key;
  } catch (e) {
    clearLotterySharePurchaseAttribution();
    return null;
  }
}

export function clearLotterySharePurchaseAttribution() {
  localStorage.removeItem(LOTTERY_SHARE_PURCHASE_ATTRIBUTION_KEY);
}
